<template>
    <rkm-form
        ref="Form"
        show-legend
        v-if="loaded"
    >
        <rkm-area
            type="fieldset"
            title="Filtro"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.mesesAno"
                        label="Competência"
                        show-default-option
                        text-field="text"
                        v-model="model.mesAno"
                        value-field='value'
                        :validations="validations.mesAno"
                        @change="getUnidades"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="unidades"
                        label="Unidade"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.unidadeId"
                        defaultOptionText="Todas"
                        value-field='id'
                        @change="getInfraestruturas"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="infraestruturas"
                        label="Local de atendimento"
                        show-default-option
                        text-field="nome"
                        defaultOptionText="Todos"
                        v-model="model.infraestruturaId"
                        value-field='id'
                        @change="getUsuarios"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="usuarios"
                        label="Profisisonal"
                        show-default-option
                        defaultOptionText="Todos"
                        text-field="nome"
                        v-model="model.usuarioId"
                        value-field='id'
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.fichas"
                        label="Fichas"
                        show-default-option
                        text-field="descricao"
                        defaultOptionText="Todas"
                        v-model="model.fichaId"
                        value-field='id'
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-button
                        :label="false"
                        color="primary"
                        @click="$refs.Form.validate(search)"
                    >
                        Buscar
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click="clear"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Resultado"
            v-if="isSearch"
        >
            <template v-slot:trailing>

                <rkm-button
                    :disabled="items.length === 0"
                    @click="print"
                    color="primary"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="items.length === 0"
                    @click="exportTo"
                    color="primary"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>

            <rkm-table
                :fields="fields"
                :items="items"
                sort-by="data"
                ref="Table"
            >

                <template v-slot:cell(pacienteNome)="{ item }">
                    {{ item.pacienteNome }}
                    <template v-if="item.pacienteNomeSocial">
                        <template v-if="item.pacientePreferenciaNomeId === enums.preferenciaNome.NOME_SOCIAL">
                            <strong>({{ item.pacienteNomeSocial }})</strong>
                        </template>
                        <template v-else>
                            ({{ item.pacienteNomeSocial }})
                        </template>
                    </template>
                </template>

                <template v-slot:cell(erros)="{ item }">
                    <div v-html="item.erros"></div>
                </template>

                <template v-slot:cell(actions)="{ item }">
                    <rkm-button
                        @click="$refs.Modal.open(item)"
                        title="Registros"
                        color="primary"
                        small
                    >
                        <rkm-icon icon="search" />
                    </rkm-button>
                </template>
            </rkm-table>
        </rkm-area>
    </rkm-form>
</template>

<script>
// Enums
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

// Mixins
import { repository, stringCase, data, object, formats, error, file } from "@/mixins";

// Vuex.
import { mapActions } from "vuex";

export default {
    computed: {
        validations() {
            return {
                mesAno: { required: true },
            }
        },
    },
    created() {

        this.repositories = {
            relatorioInconsistencia: this.getConectaSusRepository('atencaoBasica.relatorioInconsistencia'),
            exportacao: this.getConectaSusRepository('exportacao.atencaoBasica'),
            impressao: this.getConectaSusRepository('impressao.atencaoBasica'),
        }

        this.load()
    },
    data: () => ({
        form: {},
        model: {},
        items: [],
        unidades: [],
        infraestruturas: [],
        usuarios: [],
        loaded: false,
        isSearch: false,
        enums: { preferenciaNome },
        fields: [
            {
                key: 'data',
                label: 'Data',
                class: 'col-min text-center',
                sortable: true,
                searchable: true,
            },
            {
                key: 'ficha',
                label: 'Ficha',
                sortable: true,
                searchable: true,
            },
            {
                key: 'pacienteNome',
                label: 'Paciente',
                sortable: true,
                searchable: true,
            },
            {
                key: 'pacienteCpf',
                label: 'CPF',
                class: 'col-min text-center',
                sortable: true,
                searchable: true,
            },
            {
                key: 'pacienteCns',
                label: 'CNS',
                class: 'col-min text-center',
                sortable: true,
                searchable: true,
            },
            {
                key: 'pacienteProntuario',
                label: 'Prontuário',
                class: 'col-min text-center',
                sortable: true,
                searchable: true,
            },
            {
                key: 'profissional',
                label: 'Profissional',
                sortable: true,
                searchable: true,
            },
            {
                key: 'erros',
                label: 'Erros',
                sortable: true,
                searchable: true,
            },
            {
                key: 'totalErros',
                label: 'Total de erros',
                sortable: true,
                searchable: true,
                class: 'col-min text-center',
            },
        ],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.relatorioInconsistencia.index()
                .then(response => {

                    this.model = Object.assign(response.data.model)
                    this.form = Object.assign(response.data.form)
                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        search() {

            this.setLoading()

            this.repositories.relatorioInconsistencia.list(this.prepareData())
                .then(response => {

                    this.items = response.data
                    this.isSearch = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getUnidades() {

            this.setLoading()

            this.unidades = []
            this.model.unidadeId = null
            this.infraestruturas = []
            this.model.infraestruturaId = null
            this.usuarios = []
            this.model.usuarioId = null
            this.isSearch = false

            this.repositories.relatorioInconsistencia.getUnidades(this.prepareData())
                .then(response => {

                    this.unidades = response.data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getInfraestruturas() {

            this.setLoading()

            this.infraestruturas = []
            this.model.infraestruturaId = null
            this.usuarios = []
            this.model.usuarioId = null
            this.isSearch = false

            this.repositories.relatorioInconsistencia.getInfraestruturas(this.prepareData())
                .then(response => {

                    this.infraestruturas = response.data.infraestruturas
                    this.usuarios = response.data.usuarios
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getUsuarios() {

            this.setLoading()

            this.repositories.relatorioInconsistencia.getUsuarios(this.prepareData())
                .then(response => {

                    this.usuarios = response.data
                    this.isSearch = false
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        prepareData() {

            const mesAno = this.model.mesAno
            const unidadeId = this.model.unidadeId
            const infraestruturaId = this.model.infraestruturaId
            const usuarioId = this.model.usuarioId
            const fichaId = this.model.fichaId

            return this.camelObjectKeysToSnakeRecursive({
                mesAno, unidadeId, infraestruturaId, usuarioId, fichaId
            })
        },
        clear() {

            this.model.mesAno = null
            this.model.unidadeId = null
            this.model.infraestruturaId = null
            this.model.usuarioId = null
            this.model.fichaId = null
            this.isSearch = false

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        prepareDataWithColumns() {

            const data = this.prepareData();
            const fields = this.fields.filter((item) => item.key !== undefined);

            data.selectedCols = fields.map((f) => {

                return {
                    key: this.camelToSnake(f.key),
                    label: f.label,
                    class: f.class,
                };
            });

            return data;
        },
        print() {

            this.setLoading()

            this.repositories.impressao.relatorioInconsistencia(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        exportTo() {

            this.setLoading()

            this.repositories.exportacao.relatorioInconsistencia(this.prepareDataWithColumns())
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [repository, stringCase, data, object, formats, error, file],
    props: {
        id: { type: [Number, String], default: null },
    }
}
</script>